import React from 'react';
import { Grid, GridRow } from 'components/UI/Grid';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import './CookieConsent.scss';

export type CookieConsentProps = {
    cookie_consent_description: {
        html: string | null;
    };
    cookie_consent_agree_text: string;
    handleCookieConsent: () => void;
};

export const CookieConsent = (props: CookieConsentProps) => (
    <Grid className="CookieConsent-container">
        <GridRow horizontalAlign={'h-center'} verticalAlign={'v-stretch'}>
            <div className="CookieConsent-content">
                <span className="CookieConsent-text">
                    <PrismicHTMLParser>{props.cookie_consent_description.html}</PrismicHTMLParser>
                </span>
                <span className="CookieConsent-seperator" />
                <button className="CookieConsent-agreeText" onClick={props.handleCookieConsent}>
                    {props.cookie_consent_agree_text}
                </button>
            </div>
        </GridRow>
    </Grid>
);
